import type { TOC } from '@ember/component/template-only';
import { IncrementFor } from 'frontend-utils';

interface HotelAndMarketRevenueInsightHotelBlockHotelBlockLoadingSignature {
  Args: {};
}

const HotelAndMarketRevenueInsightHotelBlockHotelBlockLoading = <template>
  <div class="block-list">
    <IncrementFor @times={{5}}>
      <div class="block-list-item-container block-list-item-container--hotel">
        <div class="flex w-full items-center justify-between">
          <div class="subscription-title-column">
            <div class="segmentation-value-loading-state-bar long"></div>
          </div>
          <div class="sortable-column">
            <div class="segmentation-value-loading-state-bar long"></div>
          </div>
          <div class="redirect-to-hotel">
            <div class="segmentation-value-loading-state-bar long"></div>
          </div>
        </div>
      </div>
    </IncrementFor>
  </div>
</template> satisfies TOC<HotelAndMarketRevenueInsightHotelBlockHotelBlockLoadingSignature>;

export default HotelAndMarketRevenueInsightHotelBlockHotelBlockLoading;
